import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import { adminSideLinks } from '../adminRoutes';

function AdminLogsPage() {
  return (
    <DashboardShell role="ADMIN" sideLinks={adminSideLinks}>
      <div className="rounded-3xl bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-bold text-navy">Logs</h1>
        <p className="mt-2 text-sm text-slate-600">Monitor recent platform events and system logs.</p>
      </div>
    </DashboardShell>
  );
}

export default AdminLogsPage;
